import "../styles/Hero.css";
import Typewriter from "typewriter-effect";

export default function Hero() {
  return (
    <section className="hero">
      <h1 className="hero__title">
        Hi, I'm <br />
        <span className="hero__name">Callum Underwood,</span>
        <br />
        <Typewriter
          options={{
            strings: [
              "a full stack developer.",
              "a banana bread baker.",
              "a console gamer.",
              "a coffee enthusiast.",
              "a wannabe Pokémon champion.",
            ],
            autoStart: true,
            loop: true,
            delay: 80,
            deleteSpeed: 30,
          }}
        />
      </h1>
    </section>
  );
}
